import { cloneElement, type ReactElement } from "react";

/**
 * With a dark logo, the logo image twice: the dark one shown in the dark scheme and `image` in the light one, switched
 * by CSS on the document's data-re-scheme so a visitor's switch and the device's scheme apply before hydration.
 * Without one, `image` itself.
 */
export function withDarkLogo(
  image: ReactElement<{ src?: string; className?: string }>,
  dark: string | undefined,
): ReactElement {
  if (!dark) return image;
  const scheme = (name: string) =>
    image.props.className ? `${image.props.className} ${name}` : name;
  return (
    <>
      {cloneElement(image, { src: dark, className: scheme("re-scheme-dark") })}
      {cloneElement(image, { className: scheme("re-scheme-light") })}
    </>
  );
}
